'use strict'
import Api from '@/api/abstract'
import { APP_TOKEN_NAME } from '../../config/constants'

export let AUTH_LOGIN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/login`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let FORGOT_PASSWORD = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/forgot-password`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let CHANGE_PASSWORD = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/reset-password`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}
export let LOGOUT = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/logout`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}

export let GET_MY_INFO = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/me`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'get', successCallback, errorCallback, { headers, data })
}
export let REFRESH_TOKEN = (params, successCallback, errorCallback) => {
  let url = `${process.env.VUE_APP_API_URL}/admin/auth/refresh-token`
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(APP_TOKEN_NAME)}`
  }
  let data = params.payload.data
  return new Api(url, 'post', successCallback, errorCallback, { headers, data })
}
